import React, { useEffect, useRef, useState } from "react";
import s from "../layers-menu.module.scss";
import { Layer } from "../../../../interfaces/layer";
import { DebouncedFunction } from "../../useDebounceLayers";
import ModelCheckboxes from "./model-checkboxes/model-checkboxes";
import Loader from "../../../ui-kit/loader/loader";
import { useAppDispatch } from "../../../../hooks/useAppDispatch";
import { setLoading } from "../../../../services/reducers/map";
import { useAppSelector } from "../../../../hooks/useAppSelector";
import Checkbox from "../../../ui-kit/checkbox/checkbox";

interface Props {
  checkboxesLayers: Layer[];
  modelCheckboxesLayers: Layer[];
  debounce: DebouncedFunction;
  handleChangeSelectedItems: (
    id: number,
    checked: boolean,
    type: "checkbox",
  ) => void;
  allSelected: number[];
}

export default function Checkboxes({
  checkboxesLayers,
  modelCheckboxesLayers,
  debounce,
  handleChangeSelectedItems,
  allSelected,
}: Props) {
  const [scrollbarIsActive, setScrollbarIsActive] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const checkboxesContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    const handleScroll = () => {
      setScrollbarIsActive(true);
      clearTimeout(timer);
      timer = setTimeout(() => setScrollbarIsActive(false), 400);
    };

    const scrollbar = checkboxesContainerRef.current;

    if (scrollbar) {
      scrollbar.addEventListener("scroll", handleScroll);

      return () => {
        scrollbar.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const itemsInLoading = useAppSelector((store) => store.map.inLoadingLayersId);

  return (
    <>
      {modelCheckboxesLayers.length > 0 && (
        <ModelCheckboxes
          modelCheckboxesLayers={modelCheckboxesLayers}
          handleChangeSelectedItems={handleChangeSelectedItems}
          debounce={debounce}
          allSelected={allSelected}
        />
      )}
      <div
        className={`${s.checkboxesContainer} ${scrollbarIsActive && s.scrollbarActive}`}
        ref={checkboxesContainerRef}
      >
        {checkboxesLayers.map((item, idx) => {
          return (
            <label className={s.checkboxLabel} key={idx}>
              {itemsInLoading.includes(item.id) ? (
                <Loader size={24} classNameContainer={s.loader} />
              ) : (
                <>
                  <Checkbox
                    checked={allSelected.includes(item.id)}
                    onChange={(checked) => {
                      debounce(item.id, checked, "checkbox/infrastructure");
                      dispatch(setLoading({ id: item.id, loading: true }));
                      handleChangeSelectedItems(item.id, checked, "checkbox");
                    }}
                  />
                </>
              )}
              <span className={s.checkboxText}>{item.label}</span>
            </label>
          );
        })}
      </div>
    </>
  );
}
